
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reader/[bookSlug]",
      function () {
        return require("private-next-pages/reader/[bookSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reader/[bookSlug]"])
      });
    }
  